<script setup>
import { defineProps, defineEmits} from "vue";
import LinhaSubitem from "./LinhaSubitem.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "item",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:removeSubitem",
    "update:descartaSubitem",
    "update:alteraSubitem",
]);

//==================================================================//
//====================== Remove Subitem ============================//
//==================================================================//

const removeSubitem = (update) =>{

    emits('update:removeSubitem',update);

};

//==================================================================//
//===================== Descarta Subitem ===========================//
//==================================================================//

const descartaSubitem = (update) =>{

    emits('update:descartaSubitem',update);

};

//==================================================================//
//======================= Altera Subitem ===========================//
//==================================================================//

const alteraSubitem = (update) => {

    emits('update:alteraSubitem',update);

};

//==================================================================//
//======================== Subitens Headers ========================//
//==================================================================//

let subItensHeadeers = [
    { text: '',                    value: 'controles'},
    { text: 'Sequência',           value: 'sequencia'},
    { text: 'Descrição',           value: 'descricao'},
    { text: 'Quantidade',          value: 'quantidade'},
    { text: 'Valor Unitário',      value: 'valorUnitario'},
    { text: 'Valor Total',         value: 'valorTotal'},
    { text: '',                    value: 'espaco'},
]
 
</script>

<template>

    <div class="c-table-wrapper">

        <div class="c-table">

            <div class="c-table__headers">

                <div class="c-table__header" v-for="subItemHeader in subItensHeadeers"
                    :key="subItemHeader.value"
                >

                    <div class="c-table__header-content">

                        {{subItemHeader.text}}

                    </div>
                    
                </div>

            </div>
            <div class="c-table__body">

                <LinhaSubitem v-for="subItem in props?.item?.itens"
                    :key="subItem.id"
                    :dado="props?.dado"
                    :item="props?.item"
                    :subItem="subItem"
                    :controlesDesativados="props?.controlesDesativados"
                    @update:removeSubitem="removeSubitem"
                    @update:descartaSubitem="descartaSubitem"
                    @update:alteraSubitem="alteraSubitem"
                ></LinhaSubitem>

            </div>

        </div>

    </div>

</template>

<style scoped>

.c-table-wrapper{
    overflow: hidden !important;
    padding: 12px 12px 12px 12px !important;
}

.c-table{
    background: #ffffff;
    display: grid;
    grid-template-columns: max-content max-content minmax(450px,max-content) max-content max-content max-content auto;
    overflow: auto;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    border-radius: 5px;
}

.c-table__headers{
    display: contents;
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.75rem;
}

.c-table__header{
    padding: 14px 16px;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    font-weight: 700;
    background-color: #dedede;
    color: #363636;
}

.c-table__body{
    display: contents;
}

</style>
